import { CLEAR_RYFT_ONBOARDING_STEP, GET_RYFT_ONBOARDING_STEP } from "../../constants/userDocument/UserDocument"



const initialState = {
    RyftOnboardingCurrentStep: null
}
export const GetRyftOnboardingStepReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RYFT_ONBOARDING_STEP:
            console.log("payment session",action.payload)
            return {
                ...state,
                RyftOnboardingCurrentStep: action.payload,
            }
        case CLEAR_RYFT_ONBOARDING_STEP:
            return {
               ...state,
               RyftOnboardingCurrentStep: null,
            }
        default:
            return state
    }
}  